<template>
    <div class="information">
        <div class="infortitle">
            <div class="title">
                <slot name="title">标题内容</slot>
            </div>
            <slot name="moreinfo">
                <div class="moreinfo" @click="hidecontain">
                    {{moreinfo}}
                </div>
            </slot>
        </div>

        <div class="hideinfo" v-if="hideinfo">
            <slot name="hideinfo"></slot>
        </div>
        <div class="hideinfo">
            <slot name="nohideinfo"></slot>
        </div>
    </div>
</template>
<script>
export default {
    name:'Information',
    data(){
        return{
            moreinfo:'更多信息',
            hideinfo:false,
        }
    },
    methods:{
        hidecontain(){
            if(this.hideinfo === true){
                this.hideinfo = false;
                this.moreinfo = "更多信息"
            }
            else{
                this.hideinfo = true;
                this.moreinfo = "收起"
            }
            console.log('点开更多内容')
            
        },
    }
};
</script>
<style>
.information{
    /* width: 100%; */
    /* height: 100vh; */
    background: white;
    padding: 0px 15px;
    line-height: 50px;
}
.infortitle{
    display: flex;
    justify-content:space-between; 
    position: relative;
    border-bottom: 1px solid #eeeeee;
}
.title{
    font-weight: bold;
	display: flex;
}
.moreinfo{
  font-size: 14px;
  color: #1aac19;
  margin-right: 20px;
}

.moreinfo::before {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #1aac19;
  border-style: solid;
  -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  /* position: relative; */
  top: -2px;
  position: absolute;
  top: 50%;
  right: 0;
  margin-top: -4px;
}

</style>


